module.exports = __webpack_public_path__ + "static/img/05.7203c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/05.png
// module id = 2vlB
// module chunks = 1